import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTable = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M23 19V17H9V19H23ZM23 15V13H9V15H23ZM23 11V9H9V11H23ZM9 25C8.45 25 7.97917 24.8042 7.5875 24.4125C7.19583 24.0208 7 23.55 7 23V9C7 8.45 7.19583 7.97917 7.5875 7.5875C7.97917 7.19583 8.45 7 9 7H23C23.55 7 24.0208 7.19583 24.4125 7.5875C24.8042 7.97917 25 8.45 25 9V23C25 23.55 24.8042 24.0208 24.4125 24.4125C24.0208 24.8042 23.55 25 23 25H9ZM23 23V21H9V23H23Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgTable);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
